import { useCallback } from "react";

import { cn } from "@/lib/chillnn/cn";

import { Input } from "@/components/ui/input/input";

import { FormErrorMessage, FormItem, FormLabel, type FormErrorLayout } from "../../../_base/form";

import type { ChangeEventHandler, ReactNode } from "react";

type Props = {
	value: string | undefined | null;
	handleChange: (e: string) => void;
	type?: "text" | "email" | "tel"; // | 'search' | 'url'
	textAlign?: "left" | "center" | "right";

	errorMessage?: string;
	errorLayout?: FormErrorLayout;
	label?: ReactNode;
} & Pick<
	React.InputHTMLAttributes<HTMLInputElement>,
	"placeholder" | "readOnly" | "className" | "autoComplete" | "name"
>;

/**
 * テキスト入力フィールドコンポーネント
 */
export const InputTextField = ({
	value = undefined,
	handleChange: onChange,
	type = "text",
	className = "",
	errorMessage,
	errorLayout,
	label,
	textAlign,
	...inputProps
}: Props) => {
	const textAlignStyle = textAlign === "center" ? "text-center" : textAlign === "right" ? "text-right" : "text-left";

	const handleChange = useCallback<ChangeEventHandler<HTMLInputElement>>(
		(e) => {
			const { value } = e.currentTarget;
			onChange(value);
		},
		[onChange],
	);

	return (
		<FormItem className={className}>
			<FormLabel>{label}</FormLabel>
			<Input
				type={type}
				onChange={handleChange}
				value={value ?? undefined}
				className={cn(textAlignStyle, "min-w-[110px]")}
				{...inputProps}
			/>
			<FormErrorMessage layout={errorLayout}>{errorMessage}</FormErrorMessage>
		</FormItem>
	);
};
